import {Injectable} from '@angular/core';
import {EcaseHttpService} from './ecase-http.service';
import {Observable} from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class ExplorerService {

  constructor(private eCaseHttpService: EcaseHttpService) {
  }

  getDocumentClassifications(): Observable<any> {
    return this.eCaseHttpService.get('/v2_api/edm/list-document-classification');
  }

  getAclRulesByTerm(classificationId: string): Observable<any> {
    return this.eCaseHttpService.get(`/v2_api/edm/acl-by-term/${classificationId}`);
  }

  createAclRule(payload: any): Observable<any> {
    return this.eCaseHttpService.post('/v2_api/edm/create-acl-rule', payload);
  }

  updateAclRule(payload: any): Observable<any> {
    return this.eCaseHttpService.put('/v2_api/edm/update-acl-rule', payload);
  }

  deleteAclRule(ruleId: string): Observable<any> {
    return this.eCaseHttpService.delete(`/v2_api/edm/delete-acl-rule/${ruleId}`);
  }

  explorerSearch(searchObject: any): Observable<any> {
    return this.eCaseHttpService.post('/v2_api/edm/explorer-search', searchObject);
  }

  exportSelectedAsZip(documentIds: number[]): Observable<any> {
    return this.eCaseHttpService.post('/v2_api/edm/export-zip', { documentIds }, {
      responseType: 'blob'
    });
  }

  getDocumentList(request: any, isPublic: boolean): Observable<any> {
    const endpoint = isPublic ? '/v2_api/public/edm/document-list' : '/v2_api/edm/document-list';
    return this.eCaseHttpService.post(endpoint, request);
  }

  archiveDocument(edmRepositoryDocumentId: number, screenName: string): Observable<any> {
    return this.eCaseHttpService.post(
      `/v2_api/edm/document-list/archive/${edmRepositoryDocumentId}`,
      {screenName},
      undefined,
      false,
      true
    );
  }

  renameDocument(edmRepositoryDocumentId: number, newFileName: string, screenName: string): Observable<any> {
    return this.eCaseHttpService.post(
      `/v2_api/edm/document-list/rename/${edmRepositoryDocumentId}`,
      {newFileName, screenName},
      undefined,
      false,
      true
    );
  }

  replaceDocument(edmRepositoryDocumentId: number, formData: FormData, screenName: string): Observable<any> {
    formData.append('screenName', screenName);
    return this.eCaseHttpService.put(
      `/v2_api/edm/document-list/replace/${edmRepositoryDocumentId}`,
      formData,
      undefined,
      true
    );
  }

  startApprovalWorkflow(edmRepositoryDocumentId: number, screenName: string): Observable<any> {
    return this.eCaseHttpService.post(
      `/v2_api/edm/document-list/approval/start/${edmRepositoryDocumentId}`,
      {screenName},
      undefined,
      false,
      true
    );
  }
}
